<template>
  <div
    v-if="badgesToDisplay"
    class="product-badges"
    :class="{
      'product-badges--column': column,
    }"
  >
    <template v-for="(value, name) in badgesToDisplay">
      <fn-payback-badge
        v-if="name === 'payback'"
        :key="name"
        class="pb-tag"
        :payback-points="value"
      />
      <fn-tag
        v-else
        :key="`${value}-${name}`"
        class="pb-tag"
        :alert-detail="name === 'friendsPrice'"
        :discount="name === 'DISCOUNT'"
        :deal="name === 'DEAL'"
        :special-offer="name === 'SPECIAL_OFFER'"
        :promotion="name === 'BADGES_NEW' || name === 'EXCLUSIVE'"
        :payback-offer="name === 'PAYBACK_OFFER'"
      >
        <span
          v-if="value"
          v-html="value"
        />
      </fn-tag>
    </template>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    badges: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    paybackPoints: {
      type: [Object, String],
      default: null,
    },
    column: {
      type: Boolean,
    },
    hiddenBadges: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(useMainStore, {
      paybackEnabled: 'getPaybackEnabled',
    }),
    badgesToDisplay() {
      let badges = { ...this.badges };

      if (this.paybackEnabled && this.paybackPoints) {
        badges = {
          ...badges,
          payback: this.paybackPoints,
        };
      }

      // Filter badges to allow rendering somewhere else instead
      badges = Object.fromEntries(
        Object.entries(badges).filter(([key]) => {
          if (this.hiddenBadges.length) {
            return !this.hiddenBadges.includes(key.toLowerCase());
          }

          // By default, the pricetip badge is displayed in the friends price position
          return key !== 'PRICETIP';
        }),
      );

      return badges;
    },
  },
});
</script>

<style lang="scss" scoped>
.product-badges {
  display: flex;
  gap: math.div($pad, 4);

  .pb-tag {
    span {
      vertical-align: middle;
    }
  }
}
</style>
